import { render, staticRenderFns } from "./PedidosDetail.vue?vue&type=template&id=34e12d64&"
import script from "./PedidosDetail.vue?vue&type=script&lang=js&"
export * from "./PedidosDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports